export const API_KEY = 'AIzaSyDnsLdCKdxoFbJMxVfZHMDnr_SB-L-T7nA';
